import React, { useEffect } from "react";
import { Button, message } from "antd";
import { WaitCollectSearchBox } from "./SearchBox";
import { WaitCollectDataTable } from "./DataTable";
import { CollectDrawer } from "./CollectDrawer";
import { YhBox } from "@/components/YhBox";
import { useWaitCollectModel } from "./waitCollectModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { CollectBatchDrawer } from "./CollectBatchDrawer";
import { globalPrompt } from "@/components/YhMessage";

export const WaitCashCollect = () => {
	const {
		selectedData,
		selectedRowKeys,
		setCollectDrawerVisible,
		loadData,
		setCollectBatchDrawerVisible,
	} = useWaitCollectModel();

	useEffect(() => {
		loadData({ pageNum: 1 }).then()
	}, [])

	// useEffect(() => {
	// 	let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
	// 	const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
	// 	setSelectedData(selectedData)
	// }, [selectedRowKeys]);

	const onCollect = () => {
		if (selectedRowKeys && selectedRowKeys.length > 0) {
			setCollectDrawerVisible(true);
		} else {
			message.error("请选择收款账单!");
		}
	}

	const onCollectBatch = () => {
		if (selectedRowKeys && selectedRowKeys.length > 0) {
			const item = selectedData.find(item => item.billCashDetailList?.length === 0)
			if (item) {
				return globalPrompt('message', { type: 'warning', text: `编号: ${item.tradeCode}的单据未设置收款明细，请单独进行收款处理！` })
			}
			setCollectBatchDrawerVisible(true);
		} else {
			message.error("请选择收款账单!");
		}
	}

	const action = (
		<div>
			{/* <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={() => { }}
        >
          导出
        </Button> */}
			<YhAuth resCode={ResourceAuthEnum.CASH_RECEI_WILL_RECEI}>
				<Button
					className="mr-5"
					type="link"
					shape="round"
					disabled={selectedData.length !== 1}
					onClick={onCollect}
				>
					收款
				</Button>
			</YhAuth>
			<YhAuth resCode={ResourceAuthEnum.CASH_RECEI_WILL_RECEI_BATCH}>
				<Button
					className="mr-5"
					type="link"
					shape="round"
					disabled={selectedData.length < 2}
					onClick={onCollectBatch}
				>
					批量收款
				</Button>
			</YhAuth>
		</div>

	);

	return (
		<>
			<WaitCollectSearchBox />
			<YhBox title={"待收列表"} action={action}>
				<WaitCollectDataTable />
			</YhBox>
			<CollectDrawer />
			<CollectBatchDrawer />
		</>
	)
}

